import { track } from "@vercel/analytics";

export enum EventNames {
  MY_FUNCTIONS_CLICKED = "My Functions Clicked",
  EXAMPLE_FILES_ADDED = "Example Files Added",
  AUTO_STEP_TOGGLE = "Auto Step Toggle",
  PREVIOUS_CLICKED = "Previous Clicked",
  NEXT_CLICKED = "Next Clicked",
  REGENERATE_CLICKED = "Regenerate Clicked",
  STEP_INSTRUCTIONS_CHANGED = "Step Instructions Changed",
  DUPLICATE_CLICKED = "Duplicate Clicked",
  EDIT_CLICKED = "Edit Clicked",
  APP_API_CLICKED = "App API Clicked",
  SHARE_CLICKED = "Share Clicked",
  NODE_VIEW_API_CLICKED = "Node View API Clicked",
  NODE_VIEW_CODE_CLICKED = "Node View Code Clicked",
  USING_CUSTOM_MODEL = "Using Custom Model",
  COOKIES_DECLINED = "Cookies Declined",
  // Add more events as needed
}

type ExampleFilesAddedProperties = {
  fileTypes: string;
  largestFileSizeBytes: number;
};
type AutoStepToggleProperties = {
  isAuto: boolean;
};
type RegenerateClickedProperties = {
  userContext: string;
};
type StepInstructionsChangedProperties = {
  stepId: number;
  description: string;
};
type ShareClickedProperties = {
  shareableState: string;
};
// Define more property types as needed

type EventProperties = {
  //MY_FUNCTIONS_CLICKED has no properties
  //PREVIOUS_CLICKED has no properties
  //NEXT_CLICKED has no properties
  //DUPLICATE_CLICKED has no properties
  //EDIT_CLICKED has no properties
  //API_CLICKED has no properties
  [EventNames.EXAMPLE_FILES_ADDED]: ExampleFilesAddedProperties;
  [EventNames.AUTO_STEP_TOGGLE]: AutoStepToggleProperties;
  [EventNames.USING_CUSTOM_MODEL]: { isCustomModel: boolean };
  [EventNames.REGENERATE_CLICKED]: RegenerateClickedProperties;
  [EventNames.STEP_INSTRUCTIONS_CHANGED]: StepInstructionsChangedProperties;
  [EventNames.SHARE_CLICKED]: ShareClickedProperties;
  // Add more events and their properties as needed
};

// This wrapper allows type checks on the event name and properties to conform to the EventNames and EventProperties types we defined above
const trackEvent = <K extends keyof EventProperties>(
  eventName: EventNames,
  properties?: EventProperties[K]
) => {
  track(eventName, properties);
  // maybe add PostHog here for manual capture
};

export default trackEvent;
